import { getEmployee } from "Redux/Query";

export const isActiveEmployee = (state, id) => {
    const employee = getEmployee(state, id);
    if(!employee) {
        return false;
    }
    return !!employee.validSince;
};
